module.exports = __webpack_public_path__ + "assets/health_blue.2461e76a.svg";